module.exports = __webpack_public_path__ + "media/images/country_flags/am-cd4bdc6f43e05d34481226ad8337f4d6.png";